import { eventChannel } from "redux-saga";
import { put, takeEvery } from "redux-saga/effects";

import { Web3TxHash, Web3TxHashError } from "./events";
import { submitTransfer, submitTransferFailure } from "../payments/actions";

function* web3Hash({ detail }) {
  if (detail?.error) {
    yield put(submitTransferFailure(detail));
  } else {
    yield put(submitTransfer(detail));
  }
}

const Web3TxChannel = eventChannel((emitter) => {
  window.addEventListener(Web3TxHash, emitter);
  window.addEventListener(Web3TxHashError, emitter);

  return () => {
    document.removeEventListener(Web3TxHash, emitter);
    document.removeEventListener(Web3TxHashError, emitter);
  };
});

export function* watchWeb3TxChannel() {
  yield takeEvery(Web3TxChannel, web3Hash);
}
